import { requestWorkflowRestart as postWorkflowRestart } from '@/console/api/workflowRestart'
import { WorkflowRestartRequest, WorkflowRestartResponse } from '@/console/api/types'

/** 워크플로 restart. `api/workflowRestart.ts` 로 그대로 위임한다 — 재시도를 얹지 않는다. */
export const requestWorkflowRestart = (request: WorkflowRestartRequest): Promise<WorkflowRestartResponse> => postWorkflowRestart(request)
